module.exports = __webpack_public_path__ + "img/silver.eab0920.png";